import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/** "Showing 1 to 10 of 48", page numbers with gaps, previous / next and the page size. Pages start at 1. */
export default function Pager({ page, pageSize, total, onPage, onPageSize, sizes = [10, 25, 50], noun = 'call' }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const shown = [...new Set([1, page - 1, page, page + 1, pages])].filter((n) => n >= 1 && n <= pages).sort((a, b) => a - b);
  const from = total ? (page - 1) * pageSize + 1 : 0;
  return (
    <div className="cl-pager">
      <span>Showing {from} to {Math.min(page * pageSize, total)} of {total} {noun}{total === 1 ? '' : 's'}</span>
      <div>
        <button type="button" aria-label="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}><ChevronLeft size={14} /></button>
        {shown.map((n, i) => (
          <React.Fragment key={n}>
            {i > 0 && n - shown[i - 1] > 1 && <span className="cl-gap">…</span>}
            <button type="button" className={n === page ? 'on' : ''} aria-current={n === page ? 'page' : undefined} onClick={() => onPage(n)}>{n}</button>
          </React.Fragment>
        ))}
        <button type="button" aria-label="Next page" disabled={page >= pages} onClick={() => onPage(page + 1)}><ChevronRight size={14} /></button>
        <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))} aria-label="Calls per page">
          {sizes.map((s) => <option key={s} value={s}>{s} / page</option>)}
        </select>
      </div>
    </div>
  );
}
